import React, { useState } from 'react';
import { FiPlus, FiTag } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import PurchaseSidebar from '../components/PurchaseSidebar';
import GenericAddModal from '../components/GenericAddModal';
import useLocalState from '../hooks/useLocalState';
import { sortData } from '../utils/tableUtils';

const initialData = [
  {
    id: 'si2605-0001',
    ref: 'SI2605-0001',
    refSup: '00034764',
    third: 'Mei Yik Company',
    date: '05/15/2026',
    due: '05/15/2026',
    amtExcl: '2,800.00',
    amtInc: '2,800.00',
    paid: '0.00',
    remain: '2,800.00',
    status: 'Validated',
    items: [
      { desc: 'SS10 - 會展優惠', extra: '', tax: '0%', up: '380.05', qty: 5, disc: '78.95%', total: '400.00' },
      { desc: 'S102A - 納米美白去斑精華 50ml', extra: '', tax: '0%', up: '438.12', qty: 3, disc: '81.74%', total: '240.00' },
      { desc: '-077 - 膠原透明質酸 100ml', extra: '', tax: '0%', up: '380.05', qty: 5, disc: '78.95%', total: '400.00' },
      { desc: 'S106A - 油控暗瘡精華 50ml', extra: '', tax: '0%', up: '479.90', qty: 3, disc: '83.33%', total: '240.00' },
      { desc: 'S115A - 藍銅胜太修護精華 50ml', extra: '', tax: '0%', up: '299.96', qty: 2, disc: '73.33%', total: '160.00' },
      { desc: '-103S - 保濕修復醒膚水 150ml', extra: '', tax: '0%', up: '479.90', qty: 2, disc: '83.33%', total: '160.00' },
      { desc: '108S - 玫瑰花瓣保濕露 300ml', extra: '', tax: '0%', up: '1,200.00', qty: 2, disc: '75%', total: '600.00' },
      { desc: 'L\'S031 - 極致水潤舒敏霜 50ml(已取1)', extra: '', tax: '0%', up: '600.00', qty: 5, disc: '80%', total: '600.00' },
      { desc: 'L\'S023s - 高效抗敏感水光針3mlx6支/盒(已取1)', extra: '', tax: '0%', up: '300.00', qty: 2, disc: '100%', total: '0.00' },
      { desc: '106S - 氨基酸潔面膏100ml', extra: '', tax: '0%', up: '0.00', qty: 0, disc: '0%', total: '0.00' },
      { desc: 'SS - 已付轉數快 送貨', extra: '', tax: '0%', up: '0.00', qty: 0, disc: '0%', total: '0.00' }
    ]
  },
  {
    id: 'si2604-0001',
    ref: 'SI2604-0001',
    refSup: 'I26K/0066',
    third: 'AMICA BEAUTY SUPPLIES CO.',
    date: '04/15/2026',
    due: '04/15/2026',
    amtExcl: '420.00',
    amtInc: '420.00',
    paid: '0.00',
    remain: '420.00',
    status: 'Validated',
    items: [
      { desc: '8111M - HYDRATANT CLEANSING MILK 200ml.', extra: '', tax: '0%', up: '350.00', qty: 3, disc: '60%', total: '420.00' }
    ]
  },
  {
    id: 'prov15',
    ref: '(PROV15)',
    refSup: 'well123',
    third: 'WELL MAY INTERNATIONAL GROUP',
    date: '12/20/2025',
    due: '01/31/2026',
    amtExcl: '20,000.00',
    amtInc: '20,000.00',
    paid: '0.00',
    remain: '20,000.00',
    status: 'Validated',
    items: [
      { desc: 'WOW_CURL_CREAM - WOW CURL CREAM', extra: '(Country of origin: South Korea)', tax: '0%', up: '100.00', qty: 200, disc: '0%', total: '20,000.00' }
    ]
  }
];

export default function PurchaseRecords() {
  const [data, setData] = useLocalState('purchase_invoices_data_v4', initialData);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: 'date', direction: 'desc' });
  const [selectedYear, setSelectedYear] = useState('All');
  const [itemsPerPage, setItemsPerPage] = useState(20); // Added items per page state

  const handleAdd = (newData) => {
    const newId = 'si' + Date.now();
    setData([
      { ...newData, id: newId, status: 'Draft', paid: '0.00', remain: newData.amtInc || '0.00', amtExcl: newData.amtInc || '0.00', items: [] },
      ...data
    ]);
  };

  const handleSort = (key) => setSortConfig({ key, direction: sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc' });
  
  const sortedData = sortData(data, sortConfig);
  const filteredData = sortedData.filter(row => selectedYear === 'All' || row.date.includes(selectedYear));
  
  // Limit the displayed data based on itemsPerPage
  const displayedData = itemsPerPage === 'All' ? filteredData : filteredData.slice(0, itemsPerPage);

  return (
    <div className="flex h-full font-sans overflow-hidden bg-white">
      <PurchaseSidebar />
      <div className="flex-1 flex flex-col bg-[#a6e4e7] p-2">
        <div className="flex justify-between items-center mb-3 px-1">
          <div className="flex items-center space-x-2">
            <FiTag className="text-xl text-teal-800" />
            <span className="font-medium text-[15px] text-teal-700">Supplier Invoices ({filteredData.length})</span>
          </div>
          
          <div className="flex items-center space-x-2">
            <select 
              value={selectedYear} 
              onChange={(e) => setSelectedYear(e.target.value)}
              className="border border-gray-300 bg-white py-1 px-2 text-[12px] rounded-sm outline-none shadow-sm cursor-pointer text-gray-700 font-medium"
            >
              <option value="All">All Years</option>
              <option value="2026">Year: 2026</option>
              <option value="2025">Year: 2025</option>
            </select>

            <select 
              value={itemsPerPage} 
              onChange={(e) => setItemsPerPage(e.target.value === 'All' ? 'All' : Number(e.target.value))}
              className="border border-gray-300 bg-white py-1 px-2 text-[12px] rounded-sm outline-none shadow-sm cursor-pointer text-gray-700 font-medium"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={20}>20</option>
              <option value="All">All</option>
            </select>
            
            <button onClick={() => setIsModalOpen(true)} className="bg-[#0000a0] text-white p-1.5 rounded hover:bg-blue-900 shadow-sm transition-colors">
              <FiPlus />
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-x-auto bg-white border border-black shadow-sm">
          <table className="min-w-full border-collapse text-[12px]">
            <thead>
              <tr className="bg-[#a6e4e7] text-teal-900">
                <th onClick={() => handleSort('ref')} className="p-2 border border-black text-left cursor-pointer hover:bg-teal-200 transition-colors">Ref.</th>
                <th onClick={() => handleSort('refSup')} className="p-2 border border-black text-left cursor-pointer hover:bg-teal-200 transition-colors">Supplier Ref.</th>
                <th onClick={() => handleSort('third')} className="p-2 border border-black text-left cursor-pointer hover:bg-teal-200 transition-colors">Supplier</th>
                <th onClick={() => handleSort('date')} className="p-2 border border-black text-left cursor-pointer hover:bg-teal-200 transition-colors">Date</th>
                <th onClick={() => handleSort('amtInc')} className="p-2 border border-black text-right cursor-pointer hover:bg-teal-200 transition-colors">Amount</th>
                <th className="p-2 border border-black text-center">Status</th>
              </tr>
            </thead>
            <tbody>
              {displayedData.map((row, idx) => (
                <tr key={idx} className="hover:bg-blue-50 transition-colors">
                  <td className="p-2 border border-black font-bold">
                    <Link to={`/invoice/supplier/${row.id}`} className="text-blue-600 hover:underline">{row.ref}</Link>
                  </td>
                  <td className="p-2 border border-black text-gray-600">{row.refSup}</td>
                  <td className="p-2 border border-black">{row.third}</td>
                  <td className="p-2 border border-black">{row.date}</td>
                  <td className="p-2 border border-black text-right font-medium">{row.amtInc}</td>
                  <td className="p-2 border border-black text-center">
                    <span className={`px-2 py-0.5 rounded border text-[11px] font-medium ${row.status === 'Draft' ? 'bg-gray-100 text-gray-600 border-gray-300' : 'bg-[#fffbe6] text-[#faad14] border-[#ffe58f]'}`}>
                      {row.status}
                    </span>
                  </td>
                </tr>
              ))}
              {displayedData.length === 0 && (
                <tr>
                  <td colSpan="6" className="p-8 text-center text-gray-500 italic">
                    No supplier invoices found for {selectedYear !== 'All' ? selectedYear : 'the selected period'}.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <GenericAddModal
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          onAdd={handleAdd}
          title="Add Supplier Invoice"
          fields={[
            { name: 'ref', label: 'Reference' },
            { name: 'refSup', label: 'Supplier Ref.' },
            { name: 'third', label: 'Supplier' },
            { name: 'date', label: 'Date' },
            { name: 'amtInc', label: 'Amount' }
          ]}
        />
      </div>
    </div>
  );
}